export const questions: Array<any> = [
    {
        '_id': '001',
        'com_question': 'Hi! I\'m Eva, your personal assistant.  I will be asking you a few questions upfront to cut out the back-and-forth later and save you time. Does that sound good to you?',
        'serialNo': 1,
        'service': 'Both',
        'hg_com_rules': []
    },
    {
        '_id': '002',
        'com_question': 'My goal is to better understand your business needs so that we can recommend energy plans worth considering, and let you choose. Let\'s get started!',
        'com_question_mob': 'My goal is to better understand your business needs so that we can recommend energy plans worth considering, and let you choose. As I mentioned, my name is Eva, what is yours?',
        'serialNo': 2,
        'service': 'Both',
        'hg_com_rules': []
    },
    {
        '_id': '003',
        'com_question': 'Great! Nice to meet you <Firstname>! Please tell me, what is the nature of your business?',
        'serialNo': 3,
        'service': 'Both',
        'hg_com_rules': [],
        'tip': 'Choose the industry that closely matches yours'
    },
    {
        '_id': '004',
        'com_question': 'Let\'s find your service address. For which location are you interested in receiving a custom energy quote?',
        'serialNo': 4,
        'service': 'Both',
        'hg_com_rules': [],
        'tip1': 'You will be given an opportunity later to add another location. For now, if you have multiple meters at this location, please enter them here.  Our process  begins once we have received recent copies of your energy bills. It will help to have that information handy. Could you go ahead and obtain them now?',
        'tip2': 'You will be given an opportunity later to add another location. For now, if you have multiple meters at this location, please enter them here.',
        'remember_question': 'Remember I texted earlier about saving time? Our process begins once we have received recent copies of your energy bills. I’ll be asking you a few questions, therefore making your bills available will be very helpful. Could you go ahead and get them?',
        'esiid_q1': 'Great! Please enter your ESIID.',
        'esiid_q2': 'Okay, what is the ESI ID number?',
        'add_esiid': 'Would you like to add another ESI ID?',
        'exit_question': 'No worries. We just won’t be able to start our complimentary bill analysis until we have everything. '
    },
    {
        '_id': '005',
        'com_question': 'Do you lease or own your building?',
        'serialNo': 5,
        'service': 'Both',
        'hg_com_rules': []
    },
    {
        '_id': '006',
        'com_question': 'What is the average monthly energy bill for your location at <enter street address>?',
        'serialNo': 6,
        'service': 'Both',
        'hg_com_rules': []
    },
    {
        '_id': '007',
        'com_question': 'How many sqft of air-conditioned space does the business occupy?',
        'serialNo': 7,
        'service': 'Both',
        'hg_com_rules': [],
        'tip': 'If you don\'t know your exact square footage, please provide a range (eg. 9100 - 9500)',
    },
    {
        '_id': '008',
        'com_question': 'Which of the following investments have you made to improve your operation’s energy efficiency?',
        'serialNo': 8,
        'service': 'Both',
        'hg_com_rules': [],
        'tip': 'We will be happy to connect you with some of our trusted partners to help further lower your energy bills.'
    },
    {
        '_id': '009',
        'com_question': 'Okay, so what brings you here today?',
        'serialNo': 9,
        'service': 'Both',
        'hg_com_rules': []
    },
    {
        '_id': '0010',
        'com_question': 'Are you currently in contract?',
        'serialNo': 10,
        'service': 'Switching Providers',
        'hg_com_rules': [],
        'tip': 'If you have a copy of your most recent electricity bill, you should see your contract expiration date stated somewhere in the contract or account details sections.'
    },
    {
        '_id': '0011',
        'com_question': 'When would you like to switch?',
        'serialNo': 11,
        'service': 'Switching Providers',
        'hg_com_rules': []
    },
    {
        '_id': '0012',
        'com_question': 'What type of project is this?',
        'serialNo': 12,
        'service': 'New Service',
        'hg_com_rules': []
    },
    {
        '_id': '0013',
        'com_question': 'When do you need to start service?',
        'serialNo': 13,
        'service': 'New Service',
        'hg_com_rules': []
    },
    {
        '_id': '0014',
        'com_question': 'Have you received all necessary city permits and inspections in order to establish service in your company name?',
        'serialNo': 14,
        'service': 'New Service',
        'hg_com_rules': []
    },
    {
        '_id': '0015',
        'com_question': 'Would you like to add another location?',
        'serialNo': 15,
        'service': 'Both',
        'hg_com_rules': []
    },
    {
        '_id': '0016',
        'com_question': 'Which product type is of interest to you?',
        'serialNo': 16,
        'service': 'Both',
        'hg_com_rules': [],
        'tip1': '<u><b>A fixed rate</b></u> product is when the energy charge does not change (ie fixed) for the duration of the contract.',
        'tip2': '<u><b>A variable & index rate</b></u> product allows your energy charge to fluctuate each month based on market volatility. It is usually tied to an underlying index, like the monthly closing price of the NYMEX natural gas futures contract.'
    },
    {
        '_id': '0017',
        'com_question': 'What contract term or length are you wanting?',
        'serialNo': 17,
        'service': 'Both',
        'hg_com_rules': [],
    },
    {
        '_id': '0018',
        'com_question': 'Do you have any special contract or billing requirements?',
        'serialNo': 18,
        'service': 'Both',
        'hg_com_rules': []
    },
    {
        '_id': '0019',
        'com_question': 'Excellent, I can help with that! What is the legal name of the business?',
        'serialNo': 19,
        'service': 'Both',
        'hg_com_rules': []
    },
    {
        '_id': '0020',
        'com_question': 'How many years has your company operated this location under the same ownership?',
        'serialNo': 20,
        'service': 'Both',
        'hg_com_rules': [],
        'tip': 'If you\'re a relatively young company, you don\'t want to bind yourself into a long-term contract.  Also, if your credit was ever to be questioned, many energy providers like to know the longevity of the company\'s ownership managing the business'
    },
    {
        '_id': '0021',
        'com_question': 'How many total locations does the existing ownership manage?',
        'serialNo': 21,
        'service': 'Both',
        'hg_com_rules': []
    },
    {
        '_id': '0022',
        'com_question': 'What is your contact info?',
        'serialNo': 22,
        'service': 'Both',
        'hg_com_rules': []
    },
    {
        '_id': '0023',
        'com_question': 'Generally, when is the best time to contact you?',
        'serialNo': 23,
        'service': 'Both',
        'hg_com_rules': []
    },
    {
        '_id': '0024',
        'com_question': 'How did you hear about us? We intend to thank whoever referred you.',
        'serialNo': 24,
        'service': 'Both',
        'hg_com_rules': []
    }
];